import React from 'react'
import styled from 'styled-components'
import {
  Link,
  useListingConfig,
  ListingTypesEnum,
  useListingMeta,
  useListingBreadcrumbs,
} from '@sentecacommerce-theme/lib'
import {
  Typography,
  Placeholder,
  IconChevronRight,
  IconFilter,
} from '../../../Common'

export const TitleAndIcon = ({ showFilters }: { showFilters: () => void }) => {
  const { type } = useListingConfig()
  const { displayName } = useListingMeta()
  const { last: prevLink } = useListingBreadcrumbs()

  return (
    <TitleColumn>
      <TitleAndIconContainer>
        <Link href={prevLink?.link || '/'}>
          <StyledRightArrow />
        </Link>
        <Title search={type === ListingTypesEnum.Search}>
          {displayName || (
            <Placeholder
              className="mx-auto"
              style={{ height: '2.8rem' }}
              width="33%"
            />
          )}
        </Title>
        <div className="ml-3">
          <IconFilter style={{ width: '2.5rem' }} onClick={showFilters} />
        </div>
      </TitleAndIconContainer>
    </TitleColumn>
  )
}

const TitleColumn = styled.div.attrs({ className: 'col-12' })`
  margin-top: 2.1rem !important;

  @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
    margin-top: 1.5rem;
  }
`
const TitleAndIconContainer = styled.div.attrs({
  className: 'd-flex align-items-center mb-4 my-lg-0',
})`
  justify-content: space-between;

  & svg {
    height: 100%;
    width: 2rem;
    color: ${({ theme }) => theme.palette.greyTitle};
    @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
      display: none;
      padding-top: 3rem !important;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md.max}) {
    justify-content: center;
    margin-top: 1.5rem;
  }
  @media screen and (min-width: 768px) and (max-width: 768px) {
    margin-bottom: 2rem;
  }
`
const Title = styled(Typography).attrs((props: any) => ({
  variant: 1,
  as: 'h1',
  color: 'greyTitle',
  className: `d-flex d-md-block align-items-center justify-content-center  ${
    props.search ? 'pt-lg-4 pb-1' : 'pt-lg-0'
  }`,
}))<any>`
  text-align: center;
  line-height: 1.2;
  font-weight: bold;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm.max}) {
    text-align: center;
    max-width: calc(100% - 2.5rem - 3.5rem);
    font-size: 2rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    font-weight: normal;
  }
`
const StyledRightArrow = styled(IconChevronRight).attrs({
  className: 'mr-3',
})`
  transform: rotate(180deg);
  width: 1.5rem !important;
`
